<div [ngClass]="{'bundle-settlements-table-wrapper': !isCurrentViewSettlementsView}" data-cy="bundle-settlements-table-wrapper">
  @if (!isCurrentViewSettlementsView) {
    <div
      class="detail-title-line"
      data-cy="bundle-settlements-table-title-line">Bundle settlement(s) table
    </div>
  }
  <app-table
    (selectedLine)="loadDetailData($event)"
    [accordionLineTemplate]="accordionLineTemplate"
    [tableData]="tableData"
    tableName="table">
  </app-table>
</div>

<ng-template #accordionLineTemplate>
  <app-bundle-settlements-detail [bundleSettlementDetailData]="accordionContext"></app-bundle-settlements-detail>
</ng-template>
